/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverEarningComparisonJobResponseDto1OfDriverEarningReconstructedComparisonSummaryDtoAdmin } from '../models/DriverEarningComparisonJobResponseDto1OfDriverEarningReconstructedComparisonSummaryDtoAdmin';
import type { DriverEarningComparisonJobResponseDto1OfDriverEarningStoredComparisonSummaryDtoAdmin } from '../models/DriverEarningComparisonJobResponseDto1OfDriverEarningStoredComparisonSummaryDtoAdmin';
import type { DriverEarningComparisonJobResponseDto1OfNullable_1Admin } from '../models/DriverEarningComparisonJobResponseDto1OfNullable_1Admin';
import type { DriverEarningReconstructedComparisonSummaryRequestAdmin } from '../models/DriverEarningReconstructedComparisonSummaryRequestAdmin';
import type { DriverEarningStoredComparisonSummaryRequestAdmin } from '../models/DriverEarningStoredComparisonSummaryRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverEarningsComparisonService {
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningComparisonJobResponseDto1OfDriverEarningStoredComparisonSummaryDtoAdmin OK
     * @throws ApiError
     */
    public static postStoredSummaryAsyncAdmin({
        requestBody,
    }: {
        requestBody?: DriverEarningStoredComparisonSummaryRequestAdmin,
    }): CancelablePromise<DriverEarningComparisonJobResponseDto1OfDriverEarningStoredComparisonSummaryDtoAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-earnings/comparison/stored-summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningComparisonJobResponseDto1OfDriverEarningReconstructedComparisonSummaryDtoAdmin OK
     * @throws ApiError
     */
    public static postReconstructedSummaryAsyncAdmin({
        requestBody,
    }: {
        requestBody?: DriverEarningReconstructedComparisonSummaryRequestAdmin,
    }): CancelablePromise<DriverEarningComparisonJobResponseDto1OfDriverEarningReconstructedComparisonSummaryDtoAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-earnings/comparison/reconstructed-summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningComparisonJobResponseDto1OfNullable_1Admin OK
     * @throws ApiError
     */
    public static getJobStateAsyncAdmin({
        requestKey,
    }: {
        requestKey: string,
    }): CancelablePromise<DriverEarningComparisonJobResponseDto1OfNullable_1Admin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/comparison/jobs/{requestKey}',
            path: {
                'requestKey': requestKey,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
